import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { BackendApiService } from "../../../app/services/backend-api.service";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-create-cyclinder",
  templateUrl: "./create-cyclinder.component.html",
  styleUrls: ["./create-cyclinder.component.scss"],
  imports: [FormsModule, CommonModule, ReactiveFormsModule],
  standalone: true,
})
export class CreateCyclinderComponent implements OnInit {
  title = "Create Cyclinder";
  sites = [];
  client_id: string | number;
  applications = [];
  filteredApplications=[];
  cylinderForm = new FormGroup({
    subsystem: new FormControl("", { validators: [Validators.required] }),
    site: new FormControl("", { validators: [Validators.required] }),
    application: new FormControl("", { validators: [Validators.required] }),
  });
  constructor(private srv: BackendApiService, private route: ActivatedRoute) {
    console.log(this.route.snapshot);
    this.client_id = this.route.snapshot.queryParams["client_id"];
  }

  ngOnInit(): void {
    this.fetchClientSitesApp();
  }

  fetchClientSitesApp() {
    this.srv
      .getDataV2(`http://localhost:7778/cylinder/sites-app/${this.client_id}`)
      .then((res: any) => {
        const {code}=res.data;
        if(code==200){
          this.sites = res.data.body.sites;
          this.applications = res.data.body.applications;
          console.log(this.sites)
          console.log(this.applications);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  getEnergymeterAllSiteById(site_id: any) {
    this.filteredApplications=this.applications.filter(app=>app.site_id==site_id)

  }
  onApplicationSelect(event: any) {}

  get name() {
    return this.cylinderForm.get("name");
  }
  get subsystem() {
    return this.cylinderForm.get("subsystem");
  }
  get serialNumber() {
    return this.cylinderForm.get("serialNumber");
  }
  get site() {
    return this.cylinderForm.get("site");
  }
  get application() {
    return this.cylinderForm.get("application");
  }
  get manufacturer() {
    return this.cylinderForm.get("manufacturer");
  }
  get address() {
    return this.cylinderForm.get("address");
  }
  get state() {
    return this.cylinderForm.get("state");
  }
  get country() {
    return this.cylinderForm.get("country");
  }
  get latitude() {
    return this.cylinderForm.get("latitude");
  }
  get longitude() {
    return this.cylinderForm.get("longitude");
  }
  get gw_devicetype_id() {
    return this.cylinderForm.get("gw_devicetype_id");
  }
  get gw_device_id() {
    return this.cylinderForm.get("gw_device_id");
  }
  get energymeter_data_push_rate() {
    return this.cylinderForm.get("energymeter_data_push_rate");
  }
}
